import api from "../utils/api";
import { isGuid } from "../utils/string";
import {
    LOGOUT
} from "./types";
import { pack } from "./alert";

export const search = ({ page = 0, size = 10, order = "caption", direction = "asc", search = null }) => async (dispatch) => {
    try {
        const res = await api.get(`/cases/p/${page}/s/${size}/o/${order}/${direction}/${search}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT,
        });
    }
}

export const get = ({ uuid, staffUuid, personUuid }) => async (dispatch) => {
    try {
        let res;

        if (isGuid(uuid)) {
            res = await api.get(`/cases/i/${uuid}`);
        } else if (isGuid(personUuid) && isGuid(staffUuid)) {
            res = await api.get(`/cases/x/p/${personUuid}/s/${staffUuid}`);
        } else if (isGuid(personUuid)) {
            res = await api.get(`/cases/x/p/${personUuid}`);
        } else if (isGuid(staffUuid)) {
            res = await api.get(`/cases/x/s/${staffUuid}`);
        } else {
            return { success: false };
        }

        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const completeExtract = ({ uuid, name = "matter-complete-extract.zip", selection = null }) => async () => {
    const response = selection
        ? await api.post(
            `/cases/i/${uuid}/extract`,
            { selection },
            {
                responseType: "blob"
            }
        )
        : await api.get(
            `/cases/i/${uuid}/extract`,
            {
                responseType: "blob"
            }
        );

    const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/zip"
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();

    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true };
};

export const destroy = ({ uuid }) => async (dispatch) => {
    try {
        const res = isGuid(uuid)
            ? await api.delete(`/cases/i/${uuid}`)
            : { data: { success: false, error: { message: "Invalid matter id." } } };

        if (res.data?.success) dispatch(pack(["Matter deleted"], "success"));
        return res.data;
    } catch (err) {
        return {
            success: false,
            error: err?.response?.data?.error || err?.response?.data || { message: err?.message || "Unable to delete matter." }
        };
    }
};

export const save = (
    {
        uuid,
        clientUuid,
        parentUuid,
        parentType,
        caption,
        style,
        matterFlags,
        courtUuid,
        caseNumber,
        chambers,
        intakeDate,
        filingDate,
        filedByUuid,
        lastFilingDate,
        lastFiledByUuid,
        judgeUuid,
        assignmentDate,
        finalDate,
        status,
        pacer,
        jury
    }) => async (dispatch) => {
        try {
            const res = await api.post(`/cases`, {
                uuid,
                clientUuid,
                parentUuid,
                parentType,
                caption,
                style,
                matterFlags,
                courtUuid,
                caseNumber,
                chambers,
                intakeDate,
                filingDate,
                filedByUuid,
                lastFilingDate,
                lastFiledByUuid,
                judgeUuid,
                assignmentDate,
                finalDate,
                status,
                pacer,
                jury
            });
            dispatch(pack(["Matter saved"], "success"));
            return res.data;
        } catch (err) {
            dispatch({
                type: LOGOUT
            });
        }
    }
